import { useCallback } from 'react'
import Button, { ButtonProps } from '~components/ui/button'
import TextButton, { TextButtonProps } from '~components/ui/button/text-button'

import { useInfiniteQuery } from '@tanstack/react-query'

import Spinner from '~components/ui/loading-indicator/spinner'
import { cn } from '~utils/cn'

type LoadMoreButtonProps = Pick<
  ReturnType<typeof useInfiniteQuery>,
  'isFetchingNextPage' | 'hasNextPage' | 'fetchNextPage'
> & {
  buttonType?: 'button' | 'text'
  buttonText?: string
  className?: string
}

const LoadMoreButton = ({
  isFetchingNextPage,
  hasNextPage,
  fetchNextPage,
  buttonType = 'button',
  buttonText = 'Load more...',
  className,
}: LoadMoreButtonProps) => {
  const ButtonElement = buttonType === 'text' ? TextButton : Button
  const buttonProps: {
    text: Omit<TextButtonProps, 'children'>
    button: Omit<ButtonProps, 'children'>
  } = {
    text: {
      size: 'large',
      priority: 'primary',
    },
    button: {
      size: 'small',
      priority: 'secondary',
    },
  }

  const onSubmitPress = useCallback(() => {
    fetchNextPage()
  }, [fetchNextPage])

  return (
    <div className="flex items-center justify-center">
      {isFetchingNextPage ? (
        <div
          className={cn(
            'flex animate-fade-in-400ms items-end justify-center motion-reduce:animate-none',
            {
              'h-10': buttonType === 'button',
              'h-[54px]': buttonType === 'text',
            }
          )}
        >
          <Spinner />
        </div>
      ) : hasNextPage ? (
        <ButtonElement
          // TODO. any 빼고 타입에러 해결
          {...(buttonProps[buttonType] as any)}
          onClick={onSubmitPress}
          className={cn('animate-fade-in-400ms motion-reduce:animate-none', className)}
        >
          {buttonText}
        </ButtonElement>
      ) : null}
    </div>
  )
}

export default LoadMoreButton
